import Contributions from "../../entity/contributions"
import * as types from "./mutation_types"

const actions = {
    async getCurrentContributions({ commit, state },params) {
        // commit(types.CUREENT_USER_GET_ERROR, null);
        const url = process.env.VUE_APP_API_URL + "api/v1/conftreatisesubmit";
        if (state.isCurrentContributionsFetched !=null) {
          await state.isCurrentContributionsFetched
          return state.currentContributions
        } else {
          const waitableFetch = new Promise((resolve) => {
            this.currentContributionsResolver = resolve      
          });
          commit('setCurrentContributionsFetchPromise', waitableFetch);
          const contribution = await axios
            .get(url, { params: {created_by_id:params.userid,conference_id:params.id} })
            .then((res) => {
              let contributions = [];
              res.data.results.forEach((x) => {
               
                contributions.push(x)
            })
              // contribution = Object.assign(contribution, res.data.results[0]);
              this.currentContributionsResolver(true)
              commit(types.CURRENT_PAPER_UPDATE, contributions);          
              return contributions;
            })
            .catch((e) => {
              commit(types.CUREENT_PAPER_ERROR, "failed to fetch current contribution");
              // return new Contributions();
              return []
            });
          return contribution
        }
      },
}

function initialState() {
  return {
    currentContributions: [],
    isCurrentContributionsFetched: null
  }
}

const state = initialState()

const getters = {}

const mutations = {
    setCurrentContributionsFetchPromise(state, waitableFetch) {
        state.isCurrentContributionsFetched = waitableFetch
      },
    [types.CURRENT_PAPER_UPDATE](state, contributions) {
        state.currentContributions = contributions;
      },
    [types.CUREENT_PAPER_ERROR](state) {
        state.currentContributions = null;
        const s = initialState();
        Object.keys(s).forEach((key) => {
          state[key] = s[key];
        });
      },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}